"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.oauthMeFactory = void 0;
const Factory = require("factory.ts");
const current_user_factory_1 = require("./current-user.factory");
const current_client_factory_1 = require("./current-client.factory");
exports.oauthMeFactory = Factory.Sync.makeFactory({
    user: current_user_factory_1.currentUserFactory.build(),
    client: current_client_factory_1.currentClientFactory.build(),
});
